import { GetMeasuresFn, GetVehicleTagsFn, Quantities } from "../../../../../rest/Misc";
import { VehicleBatchEditActions, VehicleBatchEditStoreState, ActionType } from "../BatchEdit/flux";
import { assertValue } from "../../../../utils/assert";
import { GetGroupParamsFn } from "../../../../../rest/Misc/group-params";

export class SelectGroupActionCommand
{
    private groupEditActions = new VehicleBatchEditActions();
    constructor(private getState: () => VehicleBatchEditStoreState,
        private getMeasures: GetMeasuresFn,
        private getGroupParams: GetGroupParamsFn,
        private getVehicleTags: GetVehicleTagsFn)
    {
    }
    
    execute = (type: ActionType) => {
        this.groupEditActions.setActionType(type);

        switch(type) {
            case ActionType.SetPressure:
            case ActionType.SetTemperature:
            const { ids } = this.getState();
                this.getMeasures({ VehicleId: ids[0] }).then(measures => {
                    if(this.getState().selectedAction !== type)
                        return;

                    assertValue(measures);
                    
                    const { Quantities: quantities, Units: units } = measures;
                    const qId = (type === ActionType.SetPressure) ? Quantities.Pressure : Quantities.Temperature;
                    
                    const quantity = quantities.find(q => q.Id === qId);
                    assertValue(quantity);
                    
                    const unit = units.find(u => u.Id === quantity.Units[0]);
                    assertValue(unit);
                    
                    this.groupEditActions.setUnit(unit);
                });

                this.getGroupParams({ Name: 'Vehicles', Ids: ids }).then(resp => {
                    this.groupEditActions.setAxleCount(resp.AxlesCount);
                });
            break;

            case ActionType.AddTags:
                this.getVehicleTags().then(res => {
                    if(this.getState().selectedAction !== type)
                        return;
                    this.groupEditActions.setAllTags(res.Tags);
                });
            break;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/commands/SelectGroupActionCommand.ts